import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 3);
  const padded = [...featuredArticles];
  while (padded.length < 3) {
    padded.push(articles[0]);
  }

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex flex-col items-center justify-start pt-24 md:pt-32 pb-20 md:pb-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20overlapping%20circles%20in%20crimson%20and%20deep%20amber%20tones%2C%20elegant%20geometric%20shapes%20floating%2C%20luxurious%20velvet%20texture%2C%20dramatic%20lighting%20from%20upper%20left%2C%20editorial%20magazine%20cover%20style%2C%20rich%20dark%20crimson%20and%20warm%20gold%20color%20palette%2C%20no%20text%2C%20abstract%20art%20with%20depth%20and%20dimension&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="黑料吃瓜在线背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight">
          黑料吃瓜
          <br />
          在线中心
          <br />
          每日爆料
        </h1>
        <p className="mt-6 text-sm md:text-base text-white/70 max-w-xl mx-auto leading-relaxed">
          直达51黑料吃瓜在线观看、黑料吃瓜在线视频等核心栏目。最新娱乐圈黑料、主播网红塌房现场、在线吃瓜视频。
        </p>
        <Link
          to="/category/yulequan"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3 bg-accent-500 text-foreground-950 rounded-full text-sm font-bold hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          立即吃瓜
          <i className="ri-arrow-right-line"></i>
        </Link>

        <div className="mt-16 md:mt-20 relative flex items-end justify-center gap-0 -mb-40 md:-mb-52">
          {padded.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`relative w-44 md:w-56 flex-shrink-0 cursor-pointer transition-transform duration-300 hover:scale-105 ${
                index === 0
                  ? 'z-10 -rotate-6 translate-x-12 md:translate-x-16 translate-y-6'
                  : index === 1
                    ? 'z-20 -translate-y-4 scale-110'
                    : 'z-10 rotate-6 -translate-x-12 md:-translate-x-16 translate-y-6'
              }`}
            >
              <div className="bg-background-50 rounded-xl overflow-hidden shadow-lg">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="p-3">
                  <h4 className="text-xs font-semibold text-foreground-950 line-clamp-1">{article.title}</h4>
                  <p className="text-xs text-secondary-500 mt-1">{article.date}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}